import { render, staticRenderFns } from "./UsersModule.vue?vue&type=template&id=d051d5aa&scoped=true&"
import script from "./UsersModule.vue?vue&type=script&lang=js&"
export * from "./UsersModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d051d5aa",
  null
  
)

export default component.exports